import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
    return (
        <div className="footer-container1">
            <footer className="footer-wrapper">
                <div className="footer-container">
                    <div className="footer-grid">
                        <div className="footer-brand-col footer-column">
                            <div className="footer-logo-wrapper">
                                <span className="footer-logo-text">Idensite</span>
                            </div>
                            <p className="section-content footer-description">
                                Professioneel webdesign en -ontwikkeling voor Belgische vakmannen.
                                Duidelijke communicatie, snelle oplevering en websites die echt
                                resulteren in meer omzet voor uw bedrijf.
                            </p>
                            {/*<div className="footer-social-links">
                                <a href="#">
                                    <div aria-label="LinkedIn" className="footer-social-icon">
                                        <svg
                                            width="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <g
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="M8 11v5m0-8v.01M12 16v-5m4 5v-3a2 2 0 1 0-4 0"></path>
                                                <path
                                                    d="M3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"></path>
                                            </g>
                                        </svg>
                                    </div>
                                </a>
                                <a href="#">
                                    <div aria-label="Facebook" className="footer-social-icon">
                                        <svg
                                            width="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                d="M7 10v4h3v7h4v-7h3l1-4h-4V8a1 1 0 0 1 1-1h3V3h-3a5 5 0 0 0-5 5v2z"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            ></path>
                                        </svg>
                                    </div>
                                </a>
                                <a href="#">
                                    <div aria-label="Instagram" className="footer-social-icon">
                                        <svg
                                            width="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <g
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path
                                                    d="M4 8a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"></path>
                                                <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0m7.5-4.5v.01"></path>
                                            </g>
                                        </svg>
                                    </div>
                                </a>
                            </div>*/}
                        </div>
                        <div className="footer-column">
                            <h3 className="footer-column-title section-subtitle">
                                Navigatie
                            </h3>
                            <nav className="footer-nav">
                                <ul className="footer-link-list">
                                    <li>
                                        <a href="#">
                                            <div className="footer-link">
                                                <span>Home</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#proces">
                                            <div className="footer-link">
                                                <span>Proces</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#prijzen">
                                            <div className="footer-link">
                                                <span>Prijzen</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        {/*<a href="#voorbeelden">
                                            <div className="footer-link">
                                                <span>Examples</span>
                                            </div>
                                        </a>*/}
                                    </li>
                                    <li>
                                        <a href="#contact">
                                            <div className="footer-link">
                                                <span>Contact</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div className="footer-column">
                            <h3 className="footer-column-title section-subtitle">
                                Neem contact op
                            </h3>
                            <div className="footer-contact-info">
                                <div className="footer-contact-item">
                                    <div className="footer-icon-box">
                                        <svg
                                            width="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <g
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                                                <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                                            </g>
                                        </svg>
                                    </div>
                                    <a href="mailto:contact@idensite.be?subject=">
                                        <div className="footer-link">
                                            <span>contact@idensite.be</span>
                                        </div>
                                    </a>
                                </div>
                                <div className="footer-contact-item">
                                    <div className="footer-icon-box">
                                        <svg
                                            width="24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            ></path>
                                        </svg>
                                    </div>
                                    <a href="tel:+32470111513">
                                        <div className="footer-link">
                                            <span>+32 0470 11 15 13</span>
                                        </div>
                                    </a>
                                </div>
                                <div className="footer-cta-wrapper">
                                    <a href="#contact">
                                        <div className="footer-cta btn-primary btn btn-sm">
                                            <span>Project starten</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="footer-divider"></div>
                        <div className="footer-bottom-content">
                            <p className="footer-copyright">
                                &amp;copy; 2026 Idensite. All rights reserved.
                            </p>
                            <div className="footer-legal-links">
                                <button
                                    type="button"
                                    data-action="open-privacy-modal"
                                    className="footer-thq-thq-footer-legal-link-elm-elm footer-legal-link button"
                                >
                                    <span>Privacy Policy</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="footer-container2">
                <div className="footer-container3">
                    <Script
                        html={`<script defer data-name="footer-interactivity">
(function(){
  // Simple scroll reveal for footer elements
  const observerOptions = {
    root: null,
    threshold: 0.1,
    rootMargin: "0px",
  }

  const footerObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const columns = entry.target.querySelectorAll(".footer-column")
        columns.forEach((col, index) => {
          col.style.opacity = "1"
          col.style.transform = "translateY(0)"
          col.style.transition = \`opacity 0.6s ease \${index * 0.15}s, transform 0.6s ease \${index * 0.15}s\`
        })
        footerObserver.unobserve(entry.target)
      }
    })
  }, observerOptions)

  const footerGrid = document.querySelector(".footer-grid")
  if (footerGrid) {
    const columns = footerGrid.querySelectorAll(".footer-column")
    columns.forEach((col) => {
      col.style.opacity = "0"
      col.style.transform = "translateY(20px)"
    })
    footerObserver.observe(footerGrid)
  }
})()
</script>`}
                    ></Script>
                </div>
            </div>
        </div>
    )
}

export default Footer
